<script>
export default {
    name: 'BaseInput',

    props: {
        value: {
            type: String,
        },
    },

    data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'input' + Math.random()
        }
    },
}
</script>

<template>
    <div class="base-input"
      :class="{
        'has-value': value && value.length,
        'focused': focused
      }">
        <label :for="`${uid}`">
            <div class="label-text">
                <slot name="label"/>
            </div>
        </label>
        <div class="input-wrapper">
            <div class="before">
                <slot name="before"/>
            </div>
            <input
              @focus="focused = true"
              @blur="focused = false"
              v-on="$listeners"
              :value="value"
              :id="`${uid}`"
              v-bind="$attrs">
            <div class="after">
                <slot name="after"/>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
// @import '../assets/css/base.styl'

.base-input
    font-size 1.4em
    height 3.8em
    display block
    position relative
    border-bottom 2px solid $AkGreyscaleMediumUltGrey
    cursor text

    .label-text
    input
        padding-left .4em
        padding-right .4em

    label
        position absolute
        top 0
        left 0
        right 0
        bottom 0
        cursor text
        z-index 1

    .label-text
        transition ease .2s all
        display block
        position absolute
        top 50%
        transform translateY(-50%)
        font-size inherit
        color $AkGreyscaleBlack

    .input-wrapper
        display flex
        align-items center
        opacity 0
        background transparent
        position absolute
        top 50%
        width 100%
        transform translateY(-20%)
        font-size inherit

        input
            flex-grow 1
            flex-shrink 1
            padding-top 0
            padding-bottom 0
            border 0
            min-width 0
            box-sizing border-box
            color $AkGreyscaleBlack
            font-family inherit
            font-size inherit

            &::placeholder
                transition color ease 0s
                color transparent

            &:focus
                outline 0

                &::placeholder
                    transition color ease .3s .1s
                    color var(--AkGreyscaleMediumLtGrey)
    &.focused
    &.has-value
        label
            z-index 0

        .label-text
            top 0px
            font-weight bold
            transform translateY(0)
            font-size 0.7em
            padding-left 0
            padding-right 0
            color var(--mainColor)

        .input-wrapper
            opacity 1

    &.focused
        border-color var(--mainColor)

    &.has-errors
        border-color $AkMajorCoral

        .label-text
            color $AkMajorCoral

    &.base-input-small
        font-size 1.15em

</style>